import React from "react";
import "./mutiIconLayout.less"

function MutiIconLayout(props) {
    const {info} = props;
    return (
        <div className="mutiIconLayout w1200">
            <ul className="session clear-fix">
                {
                    info.map((item,index) => {
                        return (
                            <li className="item" key={index}>
                                <img className="img" src={item.icon} alt=""/>
                                <p className="title">{item.describe}</p>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default MutiIconLayout
